import { GTM_EVENTS } from './constants';

const API_TYPE_DISPLAY_NAMES = {
  restApi: 'REST',
  asyncApi: 'Async',
  bundles: 'Bundles',
  REST: 'REST',
  Async: 'Async',
  Bundles: 'Bundles'
};

export const mapApiTypesToDisplayNames = (types = []) => {
  return (types || []).map(t => API_TYPE_DISPLAY_NAMES[t] || t);
};

export const calculateFilteredResultsCount = ({
  apis = [],
  asyncApis = [],
  bundles = [],
  selectedGroup = [],
  selectedType = [],
  selectedCategories = [],
  searchText = ''
}) => {
  let filteredRestApis = Array.isArray(apis) ? apis : [];
  let filteredAsyncApis = Array.isArray(asyncApis) ? asyncApis : [];
  let bundlesList = Array.isArray(bundles) ? bundles : [];

  // 1. Category filtering (tag matching)
  if (Array.isArray(selectedCategories) && selectedCategories.length > 0) {
    const categoryNames = selectedCategories.map(c => String(c).toLowerCase());
    const filterByTags = items =>
      items.filter(
        e =>
          Array.isArray(e.tags) &&
          e.tags.some(tag => {
            const tagName = typeof tag === 'string' ? tag : tag?.name || '';
            return categoryNames.includes(tagName.toLowerCase());
          })
      );
    filteredRestApis = filterByTags(filteredRestApis);
    filteredAsyncApis = filterByTags(filteredAsyncApis);
  }

  // 2. Type filtering
  let filteredApis = [];
  let filteredBundles = [];
  const typeDisplayNames = mapApiTypesToDisplayNames(selectedType);
  const hasRest = typeDisplayNames.includes('REST');
  const hasAsync = typeDisplayNames.includes('Async');
  const hasBundles = typeDisplayNames.includes('Bundles');

  if (typeDisplayNames.length > 0) {
    if (hasRest && !hasAsync && !hasBundles) {
      filteredApis = filteredRestApis;
      filteredBundles = [];
    } else if (hasAsync && !hasRest && !hasBundles) {
      filteredApis = filteredAsyncApis;
      filteredBundles = [];
    } else if (hasBundles && !hasRest && !hasAsync) {
      filteredApis = [];
      filteredBundles = bundlesList;
    } else if (hasRest && hasAsync && !hasBundles) {
      filteredApis = [...filteredRestApis, ...filteredAsyncApis];
      filteredBundles = [];
    } else if (hasRest && hasBundles && !hasAsync) {
      filteredApis = filteredRestApis;
      filteredBundles = bundlesList;
    } else if (hasAsync && hasBundles && !hasRest) {
      filteredApis = filteredAsyncApis;
      filteredBundles = bundlesList;
    } else if (hasRest && hasAsync && hasBundles) {
      filteredApis = [...filteredRestApis, ...filteredAsyncApis];
      filteredBundles = bundlesList;
    }
  } else {
    filteredApis = [...filteredRestApis, ...filteredAsyncApis];
    filteredBundles = bundlesList;
  }

  // Filter by name and description
  filteredApis = filteredApis.filter(e => e && e.name && e.description);

  // Deduplicate
  const seen = new Set();
  filteredApis = filteredApis.filter(item => {
    const key = item.id || JSON.stringify(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  // 3. Group filtering
  const groups = selectedGroup || [];
  const hasGroupFilter = groups.length > 0;
  const hasCategoryFilter = Array.isArray(selectedCategories) && selectedCategories.length > 0;
  const isBundleGroupSelected = groups.includes('Bundles');
  const isContractedGroupSelected = groups.includes('Contracted');

  if (hasGroupFilter) {
    if (!isBundleGroupSelected) {
      filteredBundles = [];
    }
    if (isContractedGroupSelected) {
      filteredApis = filteredApis.filter(e => e.isContracted === true);
    }
    if (isBundleGroupSelected && hasCategoryFilter) {
      filteredBundles = [];
    }
    if (!isContractedGroupSelected) {
      filteredApis = [];
    }
  } else {
    if (hasCategoryFilter) {
      filteredBundles = [];
    }
  }

  let finalBundles = filteredBundles;
  if (searchText) {
    finalBundles = filteredBundles.filter(e =>
      e?.name?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  return finalBundles.length + filteredApis.length;
};

export const trackApiFilterChanged = ({
  filterType,
  filterValue,
  action,
  activeGroup = [],
  activeType = [],
  activeCategories = [],
  apis = [],
  asyncApis = [],
  bundles = []
}) => {
  const displayApiTypes = mapApiTypesToDisplayNames(activeType);
  const totalActiveFilters =
    (activeGroup?.length || 0) +
    (displayApiTypes?.length || 0) +
    (activeCategories?.length || 0);

  const resultsCount = calculateFilteredResultsCount({
    apis,
    asyncApis,
    bundles,
    selectedGroup: activeGroup,
    selectedType: displayApiTypes,
    selectedCategories: activeCategories
  });

  const payload = {
    event: GTM_EVENTS.FORTELLIS_EVENT,
    event_action: GTM_EVENTS.API_FILTER_CHANGED,
    filter_type: filterType,
    filter_value: filterValue,
    action,
    active_filters: {
      api_group: activeGroup || [],
      api_type: displayApiTypes || [],
      categories: activeCategories || []
    },
    total_active_filters: totalActiveFilters,
    results_count: resultsCount
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  return payload;
};

